import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/shared/providers/AuthProvider";
import { LoadingState } from "@/shared/ui/states/LoadingState";
import PendoTracker from "@/shared/analytics/PendoTracker";

interface AuthWrapperProps {
  children: React.ReactNode;
}

export const AuthWrapper: React.FC<AuthWrapperProps> = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <LoadingState message="Loading..." />;
  }

  if (!isAuthenticated) {
    // Preserve the intended destination so Login can redirect back after auth.
    // Using React Router <Navigate> keeps the browser history stack intact
    // (no full-page reload), which is required for the back button to work.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return (
    <>
      <PendoTracker />
      {children}
    </>
  );
};
